__turbopack_context__.v({
  "backdrop": "ArticleModal-module-scss-module__2ssdHa__backdrop",
  "body": "ArticleModal-module-scss-module__2ssdHa__body",
  "btn-back-arrow": "ArticleModal-module-scss-module__2ssdHa__btn-back-arrow",
  "closeBtn": "ArticleModal-module-scss-module__2ssdHa__closeBtn",
  "header": "ArticleModal-module-scss-module__2ssdHa__header",
  "modal": "ArticleModal-module-scss-module__2ssdHa__modal",
  "modal-fade-in": "ArticleModal-module-scss-module__2ssdHa__modal-fade-in",
  "modal-pop-in": "ArticleModal-module-scss-module__2ssdHa__modal-pop-in",
  "title": "ArticleModal-module-scss-module__2ssdHa__title",
});
